<template>
    <b-modal hide-footer id="ModalLimiteSessao" title="Dispositivo desconectado, por tempo inativo" @hide="fechar">
        <div>
          <div class="text-center p-0 p-md-5">
            <img :src='urlS3+"img/deslogado-limite-sessao-b2b.png"' alt="ícone aceite de termos" style="max-width:200px" />
            <p class="h5 mt-4">Você foi desconectado da sessão por ficar um tempo inativo na plataforma.</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <button @click="fechar" type="button" class="btn btn-primary mr-3 btn-login">Fazer login</button>
            </div>
          </div>
        </div>
    </b-modal>
</template>

<script>

import LoginUtils from '@/core/utils/login-utils'

export default {
  name: 'ModalLimiteSessao',
  data () {
    return {
      urlS3: process.env.VUE_APP_BASE_FILES_URL
    }
  },
  mounted () {
    let motivoLogoutForcado = LoginUtils.getMotivoSessaoLogoutForcado()
    if (motivoLogoutForcado) {
      this.$bvModal.show('ModalLimiteSessao')
    }
    LoginUtils.removeMotivoSessaoLogoutForcado()
  },
  methods: {
    fechar () {
      if (this.$configEmpresa.urlRedicionamentoLogoutForcado) {
        window.location = this.$configEmpresa.urlRedicionamentoLogoutForcado
      }
      this.$bvModal.hide('ModalLimiteSessao')
    }
  }
}
</script>
